import type { SchemaField } from '@cli-types/core-engine/schema.js'
import type { FieldRenderContext } from '@cli-types/next-adapter/forms.js'
import { renderGroupFieldLayoutTemplate } from '@next-adapter/templates/renderers/generators/form/field-jsx/render-group-field.js'
import { generateFieldJSX } from './generate-field-jsx.js'

export function renderGroupField(
  field: SchemaField,
  indent: string,
  label: string,
  context: FieldRenderContext
): string {
  const columns = field.columns || 1
  const groupFields = field
    .fields!.map((nf) => generateFieldJSX(nf, `${indent}    `, context))
    .filter(Boolean)
    .join('\n')
  if (!groupFields) return ''
  const heading =
    label && label !== field.name
      ? `${indent}<h3 className="text-lg font-medium">${label}</h3>\n`
      : ''
  return renderGroupFieldLayoutTemplate({
    heading: heading,
    indent: indent,
    columnsGrid: columns > 1 ? `grid-cols-${columns}` : 'grid-cols-1',
    groupFields: groupFields
  })
}
